import { ViewContainerRef, TemplateRef } from '@angular/core';

export function enableDisableView(
  enableView: boolean,
  viewContainer: ViewContainerRef,
  templateRef: TemplateRef<any>,
  hasView: boolean
): boolean {
  if (enableView && !hasView) {
    viewContainer.createEmbeddedView(templateRef);
    return true;
  } else if (!enableView && hasView) {
    viewContainer.clear();
    return false;
  }
  return hasView;
}
